import React, {useState, useEffect} from 'react';
import Cookies from 'js-cookie';
import CheckMark from "../../assets/Check mark.svg";
import CrossMark from "../../assets/Cross mark.svg";

const translations = {
    en: {
      managementInsights: "Management Insights",
      recommendations: "Recommendations",
      managementStrategies: "Management Strategies",
      onboardingRecommendations: "Onboarding Recommendations",
      dos: "Do's",
      donts: "Don'ts",
      teamFit: "Team Fit",
      bestWorkCulture: "Best Work Culture",
      potentialChallenges: "Potential Challenges",
      developmentPoints: "Development Points",
      interviewFocusAreas: "Interview Focus Areas",
      interviewFocusDescription: "Based on the personality profile, consider exploring these areas during interviews:",
      candidateAssessment: "Candidate Assessment",
      selfAssessment: "Self-Assessment",
      careerPreferences: "Career Preferences",
      desiredRole: "Desired Role",
      relocation: "Relocation",
      workType: "Work Type",
      selectedMotivators: "Selected Motivators",
      selectedWorkStyles: "Selected Work Styles",
      reflection: "Reflection",
      ambition: "Ambition",
      ambitionStrategy: "Ambition Strategy",
      fitnessRituals: "Fitness Rituals",
      greatestSuccess: "Greatest Success"
    },
    nl: {
      managementInsights: "Management Inzichten",
      recommendations: "Aanbevelingen",
      managementStrategies: "Management Strategieën",
      onboardingRecommendations: "Onboarding Aanbevelingen",
      dos: "Do's",
      donts: "Don'ts",
      teamFit: "Team Passendheid",
      bestWorkCulture: "Beste Werkcultuur",
      potentialChallenges: "Mogelijke Uitdagingen",
      developmentPoints: "Ontwikkelingspunten",
      interviewFocusAreas: "Interview Focusgebieden",
      interviewFocusDescription: "Op basis van het persoonlijkheidsprofiel, overweeg deze gebieden te verkennen tijdens interviews:",
      candidateAssessment: "Kandidaat Beoordeling",
      selfAssessment: "Zelfbeoordeling",
      careerPreferences: "Carrièrevoorkeuren",
      desiredRole: "Gewenste Rol",
      relocation: "Verhuizen",
      workType: "Werksoort",
      selectedMotivators: "Geselecteerde Motivatoren",
      selectedWorkStyles: "Geselecteerde Werkstijlen",
      reflection: "Reflectie",
      ambition: "Ambitie",
      ambitionStrategy: "Ambitiestrategie",
      fitnessRituals: "Fitnessrituelen",
      greatestSuccess: "Grootste Succes"
    }
  };


const SelfAssessment = ({ analysisResults, isRecruiterMode, isDutch = false, questionnaire }) => {
    const [lang, setLang] = useState(isDutch ? 'nl' : 'en');
    const t = translations[lang];

    useEffect(() => {
        const checkLanguage = () => {
            const cookieIsDutch = Cookies.get('isDutch') === 'true';
            const newLang = cookieIsDutch ? 'nl' : 'en';
            if (newLang !== lang) {
                setLang(newLang);
            }
        };
        checkLanguage();
        const interval = setInterval(checkLanguage, 1000);
        return () => clearInterval(interval);
    }, [lang]);

    return (
        <div className="flex flex-col pb-20">
            <h2 className="text-xl font-bold text-primary">
                {isRecruiterMode ? t.candidateAssessment : t.selfAssessment}
            </h2>
            <div className="flex-1 border rounded-md w-full h-fit mt-2 flex flex-col gap-4">
                {questionnaire && (
                    <div className="flex gap-6">
                        <div className="flex flex-col flex-1 gap-2 p-4">
                            <h2 className="text-lg font-bold mb-2">{t.careerPreferences}</h2>
                            <div>
                                <h3 className="font-semibold">{t.desiredRole}</h3>
                                <p>{questionnaire.careerPreferences?.desiredRole || "-"}</p>
                            </div>
                            <div>
                                <h3 className="font-semibold">{t.relocation}</h3>
                                <p>{questionnaire.careerPreferences?.relocation || "-"}</p>
                            </div>
                            <div>
                                <h3 className="font-semibold">{t.workType}</h3>
                                <p>{questionnaire.careerPreferences?.workType || "-"}</p>
                            </div>
                            <div>
                                <h3 className="font-semibold">{t.selectedMotivators}</h3>
                                <p>
                                    {(questionnaire.careerPreferences?.selectedMotivators || []).length > 0
                                        ? questionnaire.careerPreferences.selectedMotivators.join(", ")
                                        : "-"}
                                </p>
                            </div>
                            <div>
                                <h3 className="font-semibold">{t.selectedWorkStyles}</h3>
                                <p>
                                    {(questionnaire.careerPreferences?.selectedWorkStyles || []).length > 0
                                        ? questionnaire.careerPreferences.selectedWorkStyles.join(", ")
                                        : "-"}
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-col flex-1 gap-2 border-left-table p-4">
                            <h2 className="text-lg font-bold mb-2">{t.reflection}</h2>
                            <div>
                                <h3 className="font-semibold">{t.ambition}</h3>
                                <p>{questionnaire.reflection?.ambition || "-"}</p>
                            </div>
                            <div>
                                <h3 className="font-semibold">{t.ambitionStrategy}</h3>
                                <p>{questionnaire.reflection?.ambitionStrategy || "-"}</p>
                            </div>
                            <div>
                                <h3 className="font-semibold">{t.fitnessRituals}</h3>
                                <p>{questionnaire.reflection?.fitnessRituals || "-"}</p>
                            </div>
                            <div>
                                <h3 className="font-semibold">{t.greatestSuccess}</h3>
                                <p>{questionnaire.reflection?.greatestSuccess || "-"}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelfAssessment;